(function () {
    'use strict';
    angular.module(modules.homeModule).component('handbookFoderStatistics', {
        templateUrl: 'app/components/statistics/folder-statistics/folder-statistics.html',
        controller: controller,
        controllerAs: 'vm',
        bindings: {
        }
    });

    controller.$inject = ['$http', '$scope', 'configService'];
    function controller($http, $scope, configService) {
        var vm = this;

        vm.tabsChartsSetting = [];
        vm.periods = [];
        vm.subFolderStatisticsSetting = [];
        vm.defaultSelectedFolder = { id: null, name: resources.L.Common.all, type: 0 };
        vm.folderName = resources.L.Common.all;
        vm.statisticsPercentageForAwaitingApproval = configService.getBool(HandbookConfiguration.StatisticsPercentageForAwaitingApproval);

        vm.folderId = null;

        vm.getSelectedNode = getSelectedNode;
        vm.changePeriod = changePeriod;

        $scope.$on("tabStatisticsActived", function (evt, data) {
            if (data == 'folderStatistics' && (!vm.tabsChartsSetting || vm.tabsChartsSetting.length == 0)) {
                initialize();
            }
        });

        function initialize() {
            getPeriods();
            vm.selectOptionPeriod = 2;

            buildTabsSetting();
            getFolderStatistics(null, vm.selectOptionPeriod);
        }

        function buildGridSetting(nameFolder) {
            vm.subFolderStatisticsSetting = [
                { id: 'folderName', name: nameFolder, width: 30, coldefault: true, isObject: false },
                { id: 'approved', name: resources.L.Statistics.docsInUse, width: 10, coldefault: true, isObject: false, customCss: 'font-weight-normal' },
                { id: 'internet', name: resources.L.Document.internet, width: 10, coldefault: true, isObject: false, customCss: 'font-weight-normal' },
                { id: 'newCount', name: resources.L.Statistics.newThisMonth, width: 10, coldefault: true, isObject: false, customCss: 'font-weight-normal' },
                { id: 'revised', name: resources.L.Statistics.revisedThisMonth, width: 10, coldefault: true, isObject: false, customCss: 'font-weight-normal' },
                { id: 'archived', name: resources.L.Statistics.archivedThisMonth, width: 10, coldefault: true, isObject: false, customCss: 'font-weight-normal' },
                { id: 'awaitingApproval', name: resources.L.Enum.DocumentStatuses.awaitingApproval, width: 10, coldefault: true, isObject: false, customCss: 'font-weight-normal' },
                { id: 'expired', name: resources.L.Statistics.expired, width: 10, coldefault: true, isObject: false, customCss: 'font-weight-normal' }
            ];
        }

        function getPeriods() {
            vm.periods = [
                { id: 0, name: resources.L.Common.all },
                { id: 1, name: resources.L.Statistics.fiveYear },
                { id: 2, name: resources.L.Statistics.last13Months },
            ];
        }

        function buildTabsSetting() {
            vm.tabsChartsSetting.push({
                name: resources.L.Statistics.approvedVsInternet,
                description: resources.L.Statistics.approvedVsInternet,
                href: 'approveInternet',
                icon: 'fa fa-line-chart',
                tabIndex: 1,
                active: true,
                count: 0,
                activatedClass: 'home-tab-active',
                hide: false,
                url: '',
                elementContentId: 'approveInternet'
            });
            vm.tabsChartsSetting.push({
                name: resources.L.Statistics.newVsRevisedVsArchived,
                description: resources.L.Statistics.newVsRevisedVsArchived,
                href: 'newRevisedArchived',
                icon: 'fa fa-line-chart',
                tabIndex: 2,
                active: false,
                count: 0,
                activatedClass: 'home-tab-active',
                hide: false,
                url: '',
                elementContentId: 'newRevisedArchived'
            });
            vm.tabsChartsSetting.push({
                name: resources.L.Statistics.awaitingApprovalVsExpired,
                description: resources.L.Statistics.awaitingApprovalVsExpired,
                href: 'awaitingApprovedExpired',
                icon: 'fa fa-line-chart',
                tabIndex: 2,
                active: false,
                count: 0,
                activatedClass: 'home-tab-active',
                hide: false,
                url: '',
                elementContentId: 'awaitingApprovedExpired'
            });
        }

        function getFolderStatistics(folderId, type) {
            buildGridSetting(vm.folderName);

            var request = {
                handbookId: folderId,
                type: type
            };
            var promise = $http.get('/api/Documents/GetFolderStatisticsOverView', { params: request });
            promise.success(function (data, status, headers, config) {
                var result = data;
                vm.folderStatistics = result.folderStatistics;
                vm.subFolderStatistics = result.subFolderStatistics;
                buildChartApprovedInternet(result.folderStatisticsForCharts);
                buildChartNewRevisedArchived(result.folderStatisticsForCharts);
                buildChartAwaitingApprovalExpired(result.folderStatisticsForCharts);
            });
        }

        function buildChartApprovedInternet(data) {
            var approveTitle = resources.L.Document.approved;
            var internetTitle = resources.L.Document.internet;
            var categories = data.map(x => x.monthYear);
            var approvedDocs = data.map(x => x.approved);
            var internetDocs = data.map(x => x.internet);
            Highcharts.chart('approve-internet-charts-id', {
                title: {
                    text: resources.L.Statistics.approvedVsInternet
                },
                subtitle: {
                    text: ''
                },
                yAxis: {
                    title: {
                        text: resources.L.Common.number
                    }
                },
                xAxis: {
                    categories: categories
                },
                legend: {
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle'
                },
                plotOptions: {
                    series: {
                        label: {
                            connectorAllowed: false
                        },
                        pointStart: null
                    }
                },
                series: [{
                    name: approveTitle,
                    data: approvedDocs
                }, {
                    name: internetTitle,
                    data: internetDocs
                }],
                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 500
                        },
                        chartOptions: {
                            legend: {
                                layout: 'horizontal',
                                align: 'center',
                                verticalAlign: 'bottom'
                            }
                        }
                    }]
                }

            });
        }

        function buildChartNewRevisedArchived(data) {
            var categories = data.map(x => x.monthYear);
            var newCountDocs = data.map(x => x.newCount);
            var revisedDocs = data.map(x => x.revised);
            var archivedDocs = data.map(x => x.archived);

            Highcharts.chart('new-revised-archived-charts-id', {
                title: {
                    text: resources.L.Statistics.newVsRevisedVsArchived
                },
                subtitle: {
                    text: ''
                },
                yAxis: {
                    title: {
                        text: resources.L.Common.number
                    }
                },
                xAxis: {
                    categories: categories
                },
                legend: {
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle'
                },
                plotOptions: {
                    series: {
                        label: {
                            connectorAllowed: false
                        },
                        pointStart: null
                    }
                },
                series: [{
                    name: resources.L.Action.new,
                    data: newCountDocs
                }, {
                    name: resources.L.Statistics.revised,
                    data: revisedDocs
                }, {
                    name: resources.L.Common.archived,
                    data: archivedDocs
                }],
                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 500
                        },
                        chartOptions: {
                            legend: {
                                layout: 'horizontal',
                                align: 'center',
                                verticalAlign: 'bottom'
                            }
                        }
                    }]
                }

            });
        }

        function buildChartAwaitingApprovalExpired(data) {
            var categories = data.map(x => x.monthYear);
            var awaitingApprovalDocs = data.map(x => x.awaitingApproval);
            var expiredDocs = data.map(x => x.expired);

            Highcharts.chart('awaiting-approved-expired-charts-id', {
                title: {
                    text: resources.L.Statistics.awaitingApprovalVsExpired
                },
                subtitle: {
                    text: ''
                },
                yAxis: {
                    title: {
                        text: resources.L.Common.number
                    }
                },
                xAxis: {
                    categories: categories
                },
                legend: {
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle'
                },
                plotOptions: {
                    series: {
                        label: {
                            connectorAllowed: false
                        },
                        pointStart: null
                    }
                },
                series: [{
                    name: resources.L.Enum.DocumentStatuses.awaitingApproval,
                    data: awaitingApprovalDocs
                }, {
                    name: resources.L.Statistics.expired,
                    data: expiredDocs
                }],
                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 500
                        },
                        chartOptions: {
                            legend: {
                                layout: 'horizontal',
                                align: 'center',
                                verticalAlign: 'bottom'
                            }
                        }
                    }]
                }

            });


        }

        function getSelectedNode(node) {
            if (node != null) {
                vm.folderId = node.id;
                vm.folderName = node.name;
                getFolderStatistics(vm.folderId, vm.selectOptionPeriod);
            }
        }

        function changePeriod() {
            var request = {
                handbookId: vm.folderId,
                type: vm.selectOptionPeriod
            };
            var promise = $http.get('/api/Documents/GetFolderStatisticsForChart', { params: request });
            promise.success(function (data, status, headers, config) {
                var result = data;
                buildChartApprovedInternet(result);
                buildChartNewRevisedArchived(result);
                buildChartAwaitingApprovalExpired(result);
            });
        }

    }
})();